// extracted by mini-css-extract-plugin
export default {"info":"tooltipContent_info__ubGze"};